import { HandballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const BlueCardPopup = new PopupBuilder('BlueCard', {
  incident_id: HandballIncidentId.BlueCard,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
